<!--
  1Password direct import, rendered inside the parent import component's form. Collects the account
  to sign in to: its email and sign-in address. The Secret Key, password and two-factor code are
  asked for in dialogs once the import starts.
-->

<div [formGroup]="formGroup">
  <bit-form-field>
    <bit-label>{{ "onePasswordEmail" | i18n }}</bit-label>
    <input bitInput type="email" id="import-onepassword_input_email" formControlName="email" />
    <bit-hint>{{ "onePasswordEmailHint" | i18n }}</bit-hint>
  </bit-form-field>

  <bit-form-field>
    <bit-label>{{ "signInAddress" | i18n }}</bit-label>
    <input
      bitInput
      type="text"
      id="import-onepassword_input_subdomain"
      formControlName="subdomain"
      appInputVerbatim
    />
  </bit-form-field>

  <bit-form-field disableMargin>
    <bit-label>{{ "domain" | i18n }}</bit-label>
    <bit-select id="import-onepassword_bit-select_domain" formControlName="domain">
      @for (d of domains; track d.value) {
        <bit-option [value]="d.value" [label]="d.label" />
      }
    </bit-select>
  </bit-form-field>
</div>
